Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CodeSandbox", {
  enumerable: true,
  get: function get() {
    return _codesandbox.CodeSandbox;
  }
});
var _codesandbox = require("./codesandbox");